export default __webpack_public_path__ + "static/media/certificacion_basica.e2ad4eb4.svg";